import { useMemo } from 'react'

export interface DotSegment {
  key: string
  label: string
  percentage: number
  color: string
}

interface DotGridChartProps {
  segments: DotSegment[]
  size?: number
  gap?: number
}

export function DotGridChart({ segments, size = 28, gap = 4 }: DotGridChartProps) {
  const dots = useMemo(() => {
    const result: { color: string; label: string; percentage: number }[] = []

    for (const segment of segments) {
      for (let i = 0; i < segment.percentage; i++) {
        result.push({ color: segment.color, label: segment.label, percentage: segment.percentage })
      }
    }

    // Fill remaining dots if rounding leaves <100 — assign to largest segment
    while (result.length < 100) {
      const largest = segments.reduce((a, b) => a.percentage > b.percentage ? a : b)
      result.push({ color: largest.color, label: largest.label, percentage: largest.percentage })
    }

    return result.slice(0, 100)
  }, [segments])

  return (
    <div
      className="grid grid-cols-10 mx-auto"
      style={{ gap: `${gap}px`, width: `${10 * size + 9 * gap}px` }}
    >
      {dots.map((dot, i) => (
        <div
          key={i}
          title={`${dot.label} (${dot.percentage < 1 ? '<1%' : `${dot.percentage}%`})`}
          className="rounded-full transition-transform hover:scale-125 cursor-default"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: dot.color,
          }}
        />
      ))}
    </div>
  )
}
